import { AxiosRequestConfig } from 'axios';
import { IPagination } from '../../hooks/use-table/use-table.props';

class DriverLevelRequestConfig {
  companyList = (Pagination: IPagination | {} = {}): AxiosRequestConfig => ({
    method: 'POST',
    url: 'fahrerlevel/companylist',
    data: { Pagination }
  });
}

export const driverLevelRequestConfig = new DriverLevelRequestConfig();
